<form
  [formGroup]="messageForm"
  (ngSubmit)="submit()"
  class="chat-input-form bg-neutral-0 relative flex w-full flex-col gap-3 rounded-[0.75rem] border border-neutral-200 p-3 transition hover:bg-neutral-50"
>
  <quill-editor
    #quillEditor
    [formControlName]="'message'"
    [format]="'json'"
    [modules]="quillModules"
    [bounds]="'self'"
    [placeholder]="'Fix image with AI'"
    [theme]="'bubble'"
    [trimOnValidation]="true"
    [required]="true"
    class="chat-editor !inline-flex w-full text-sm font-normal"
    [ngClass]="{ 'min-h-[44px] items-start': isNonEmpty(), 'min-h-[24px] items-center': !isNonEmpty() }"
    (onEditorCreated)="editorCreated($event)"
    (onContentChanged)="contentChanged($event)"
  />

  <div class="flex items-center justify-between">
    <dojo-icon-button
      [type]="'submit'"
      [disabled]="!isChatCreated()"
      [icon]="'refresh'"
      [class]="'chat-submit-button'"
      #matMenuTriggerForMenu="matMenuTrigger"
      [matMenuTriggerFor]="menu"
    />
    <mat-menu #menu="matMenu" class="custom-mat-menu" hasBackdrop="true">
      <ng-template matMenuContent>
        <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="flex flex-col gap-2 p-4">
          <span>Are you sure you want to restart the chat? Current chat progress will be lost.</span>
          <dojo-button [size]="'s'" [fill]="'outline'" [customWidth]="100" (click)="restartChat.emit()">
            Restart chat
          </dojo-button>
        </div>
      </ng-template>
    </mat-menu>

    <dojo-icon-button
      [type]="'submit'"
      [disabled]="!messageForm.controls.message.dirty || inputDisabled() || !isChatCreated()"
      [icon]="'paper-plane-top'"
      class="chat-submit-button"
    />
  </div>
</form>
